import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"];

  connect() {
    // Add focus event listener to highlight placeholder when focused
    this.textarea.addEventListener('focus', this.highlightPlaceholder.bind(this));
    
    // Add keydown event listener for tab key
    this.textarea.addEventListener('keydown', this.handleTabKey.bind(this));

    if (this.hasPlaceholder) {
      if (document.activeElement === document.body || document.activeElement === null) {
        this.textarea.focus();
      }
    }
  }

  extendSelection() {
    const textarea = this.textarea;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;

    if (start != end && start >= 2 && end <= text.length - 2 &&
        text.substring(start - 2, start) === '[[' &&
        text.substring(end, end + 2) === ']]') {
      textarea.setSelectionRange(start - 2, end + 2);
    }
  }

  highlightPlaceholder() {
    const textarea = this.textarea
    
    // Use setTimeout to delay the selection after focus event completes
    setTimeout(() => {
      const text = textarea.value;
      
      // Find the first occurrence of text within double square brackets
      const match = text.match(/\[\[(.*?)\]\]/);
      
      if (match) {
        const startPos = match.index;
        const endPos = startPos + match[0].length;
        
        // Set selection range to highlight the placeholder including brackets
        textarea.setSelectionRange(startPos, endPos);
      }
    }, 10);
  }

    handleTabKey(event) {
    // Only handle tab key
    if (event.key === 'Tab' && this.hasPlaceholder) {
      event.preventDefault(); // Prevent default tab behavior
      this.highlightPlaceholder(); // Call the highlight function
    }
  }

  get textarea() {
    return this.hasTextareaTarget ? this.textareaTarget : this.element;
  }

  get hasPlaceholder() {
    const placeholderText = this.textarea.value;
    return placeholderText.includes("[[") && placeholderText.includes("]]");
  }
}
